export default "__VITE_ASSET__1D96aBZz__"